import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import * as Sentry from '@sentry/browser';

Sentry.init({ dsn: 'https://336d1aa060a94f8f916c1e93d6affab7@o393426.ingest.sentry.io/5244378' });

const authmodule = {
	state: {
		logged: !!window.localStorage.getItem('_token'),
		name: '',
		apellidos: '',
		nick: '',
		token: '',
		id: '',
		usertype: '',
		avisoofertas: false,
		avisoCV: false,
		esUFV: false,
		busquedaAlaCartaPermitida: false,
		idDepartamento : null,
		showPopupDireccion : true
	},
	getters: {
		getLogged: state => state.logged,
		getName: state => state.name,
		getApellidos: state => state.apellidos,
		getNick: state => state.nick,
		getid: state => state.id,
		getToken: state => state.token,
		getusertype: state => state.usertype,
		isEmpresa: state => (state.usertype == 'empresa'),
		isEstudiante: state => (state.usertype == 'practicas'),
		isAlumni: state => (state.usertype == 'empleo'),
		isUFV: state => state.esUFV,
		isCandidato: state => (state.usertype == 'empleo' || state.usertype == 'practicas'),
		getAvisoOfertas: state => state.avisoofertas,
		getAvisoCV: state => state.avisoCV,
		getidDepartamento: state => state.idDepartamento,
		getbusquedaAlaCarta: state => state.busquedaAlaCartaPermitida,
		getshowPopupDireccion: state => state.showPopupDireccion,
	},
	actions: {
		requestLogin: ({ commit, dispatch }, logindata) => {

			let urls = {
				'PrivadoAlumnoEmpleo': "/api/Alumno/logaUsuario",
				'PrivadoEstudiante': "/api/Alumno/logaUsuario",
				'PrivadoEmpresa': "/api/Empresa/logaUsuario",
				'registroEstudiantes': "/api/Alumno/confirmaAccesoPracticas",
			};

			let urllogin = urls[logindata.eAmbito];


			if (logindata.eAmbito == 'encuestaquery') {
				urllogin += '/' + logindata.urlAcceso
			}

			return new Promise((resolve, reject) => {


				axios.post(urllogin, logindata).then(response => {

					let result = response.data;

					if (result.status == 0) {

						let data = result.datos;


						window.localStorage.setItem('_token', data.token);


						let usertype = "empresa";

						(data.conEmpleo) ? usertype = 'empleo' : null;
						(data.conPracticas) ? usertype = 'practicas' : null;

						if(!!data.idDepartamento){
							window.localStorage.setItem('_idDepartamento', data.idDepartamento);
						}

						window.localStorage.setItem('_usertype', usertype);

						window.localStorage.setItem('_name', data.nombre);
						if(!!data.apellidos){
							window.localStorage.setItem('_apellidos', data.apellidos);
						}

						if(!!data.apellido1){
							window.localStorage.setItem('_apellidos', `${data.apellido1} ${data.apellido2}`);
						}

						window.localStorage.setItem('_nick', logindata.eUsuario);

						window.localStorage.setItem('_busquedaCarta', data.busquedaAlaCartaPermitida);

						window.localStorage.setItem('_showPopupDireccion', data.showPopupDireccion);
						window.localStorage.setItem('_esUFV', data.esUFV);


						commit('setLogged', data);


						(data.avisoRecibirOfertas) ? commit('setAvisoOfertas', true) : null;


						(data.avisoCVnecesario) ? commit('setAvisoCV', true) : null;


						dispatch('initApp');


						resolve(true);

					} else {

						(!!result.status) ? commit('setError', result.status) : null;
						resolve(false);
					}

				}).catch(error => {
					Sentry.captureException(error);
				});
			});
		},
		requestLogout: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				commit('setLogout');
				// dispatch('turnOffRGPD');
				// commit('removeEncuestas');
				resolve(true);
			});
		},
		checkLogged({ commit, dispatch }) {

			return new Promise((resolve, reject) => {

				const token = window.localStorage.getItem('_token');

				if (!!token) {
					const jwtDecode = require('jwt-decode');
					let data = jwtDecode(token);
					let now = Math.round((new Date().getTime() / 1000));
					if (now > data.exp) {
						commit("setLogout");
						resolve(false);
					} else {
						commit("setLogged");
						resolve(true);
					}
				} else {
					resolve(true);
				}

			});


		},
		removeAvisoOfertas({ commit }) {
			commit('setAvisoOfertas', false);
		},
		removeAvisoCV({ commit }) {
			commit('setAvisoCV', false);
		},
		modifyPass({commit,getters},data){

			let type = (getters.isEmpresa) ? 'empresa' : 'alumno';

			return new Promise((resolve, reject) => {
				axios.post(`/api/${type}/editPassword`,data).then(result => {
					if (result.data.status == 0) {
						commit('setError', 611);
						resolve(true);
					} else {
						commit('setError', result.data.status)
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		initApp({ dispatch, getters }, type) {

			dispatch("requestDominios");
			dispatch("requestTitulaciones");
			dispatch("requestProgramasInformaticos");
			dispatch("requestKeywords");
			dispatch("requestPromociones");

			if (getters.isEmpresa) {
				// EMPRESAS
				dispatch('requestAnexos');
				dispatch('requestDatosEmpresa');
				dispatch('requestContactosEmpresa');
				dispatch('requestCandidatosPracticas');
				dispatch('requestCandidatosEmpleo');
			} else {
				//CANDIDATOS
				dispatch("requestCandidaturas");
				dispatch("requestCV");
				dispatch("requestOfertas");
				
				if(getters.isEstudiante){
					dispatch("requestOfertasEstudiaTrabaja");
				}
			}

		},
		solicitarAccesoEstudiantes({ commit }, dni) {
			let data = { valor: dni };

			return new Promise((resolve, reject) => {
				axios.post("/api/Alumno/solicitarAccesoPracticas", data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
					} else {
						commit('setError', result.data.status);
						resolve(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},
		recordarPass({ commit }, data) {
			// let urls = {
			// 	'PrivadoAlumnoEmpleo': "/api/Alumno/recuerdoPasswordEmpleo",
			// 	'PrivadoEstudiante': "/api/Alumno/recuerdoPasswordPracticas",
			// 	'PrivadoEmpresa': "/api/Empresa/recuerdoPassword",
			// };
			let urls = {
				'alumni': "/api/Alumno/recuerdoPasswordEmpleo",
				'alumnos': "/api/Alumno/recuerdoPasswordPracticas",
				'empresas': "/api/Empresa/recuerdoPassword",
			};


			return new Promise((resolve, reject) => {
				axios.post(urls[data.type], data).then(result => {
					if (result.data.status == 0) {
						resolve(true);
						commit('setError', 603);
					} else {
						commit('setError', 613);
						reject(false);
					}
				}).catch(error => {
					reject(false);
				});
			});
		},

	},
	mutations: {
		setLogged(state, data) {

			if (!!window.localStorage.getItem('_token')) {

				const token = window.localStorage.getItem("_token");
				const name = window.localStorage.getItem("_name");
				const apellidos = window.localStorage.getItem("_apellidos");
				const nick = window.localStorage.getItem("_nick");
				const usertype = window.localStorage.getItem("_usertype");
				const idDepartamento = window.localStorage.getItem("_idDepartamento");
				const busquedaCarta = window.localStorage.getItem("_busquedaCarta");
				const esUFV = (window.localStorage.getItem("_esUFV") == "true");
				const showPopupDireccion = (window.localStorage.getItem("_showPopupDireccion") == "true");



				axios.defaults.headers.common['authorization'] = `Bearer ${token}`;

				Sentry.setUser({"username": `${name} ${apellidos}`});

				state.logged = true;
				state.token = token;
				state.name = name;
				state.apellidos = apellidos;
				state.nick = nick;
				state.usertype = usertype;
				state.idDepartamento = idDepartamento;
				state.busquedaAlaCartaPermitida = busquedaCarta;
				state.esUFV = esUFV;
				state.showPopupDireccion = showPopupDireccion;
			}

		},

		setLogout(state) {
			state.logged = false;
			window.localStorage.clear();
			window.sessionStorage.clear();
			window.localStorage.setItem('cookie:accepted', true);
		},

		setAvisoOfertas(state, value) {
			state.avisoofertas = value;
		},
		setAvisoCV(state, value) {
			state.avisoCV = value;
		},
		setShowPopupDireccion(state,value){
			state.showPopupDireccion = value;
		},
		editNombre(state, data) {
			state.name = data.nombre;
			state.apellidos = data.apellidos;
		}
	}
}

export default authmodule;




// WEBPACK FOOTER //
// ./src/store/authmodule.js